module.exports = __webpack_public_path__ + "img/DK28833210.a21c27b6.png";